export default __webpack_public_path__ + "static/media/panel4.0e3f3898.png";